import { CMS_MICROSITE_MESSAGE_KEY } from '../messages/messages'
import { CMS_MICROSITE_ID, CMSMicrositeMetadata } from '../types'

export const holidayStressToolkitMetadata: CMSMicrositeMetadata = {
  micrositeId: CMS_MICROSITE_ID.HOLIDAY_STRESS,
  iFrameSrcUrl: '/holidaystress',
  micrositeUrl: 'holidaystress',
  title: {
    id: 'holidaystress.title',
    defaultMessage: 'The holidays can stir up a lot of feelings',
    description: 'Microsite page title',
  },
  featureFlag: 'isHolidayStressToolkitEnabled',
  customerPropertyConditions: [
    {
      key: 'libraryDisabled',
      value: true,
    },
  ],
  postMessageEvents: [
    {
      key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_REGISTRATION,
    },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_ESSENTIALS,
    },
    { key: CMS_MICROSITE_MESSAGE_KEY.CLICK_SELF_CARE_CONTENT },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.REGISTER_WEBINAR,
      params: {
        webinarLink: '/secure/index/essentials/events/managing-mental-health-at-the-holidays',
      },
    },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_FORKED_TRIAGE,
    },
    { key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_WEBINAR_EVENTS },
  ],
  page: '202511 holidaystress',
  trackUTMParams: {
    utm_campaign: 'holidaystress202511',
  },
  customMixpanelEventProps: {
    toolkit_topic: 'holidaystress',
  },
  shouldHideForInternational: false,
}
